import DashboardIcon from '@mui/icons-material/Dashboard';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import EventIcon from '@mui/icons-material/Event';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import FolderIcon from '@mui/icons-material/Folder';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import LinkIcon from '@mui/icons-material/Link';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaymentsIcon from '@mui/icons-material/Payments';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleIcon from '@mui/icons-material/People';
import GroupsIcon from '@mui/icons-material/Groups';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import SettingsIcon from '@mui/icons-material/Settings';
import FeedbackIcon from '@mui/icons-material/Feedback';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CategoryIcon from '@mui/icons-material/Category';
import CampaignIcon from '@mui/icons-material/Campaign';
import SearchIcon from '@mui/icons-material/Search';
import BuildIcon from '@mui/icons-material/Build';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PersonIcon from '@mui/icons-material/Person';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ReceiptIcon from '@mui/icons-material/Receipt';
import GavelIcon from '@mui/icons-material/Gavel';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { TICKET_TRANSFER_ENABLED } from './ticketTransfer';

// `labelKey`, when set, is the label's key in the `layout` translations (locales/<lng>/layout.json);
// items without one show `label` as it is until their page is translated.
export const navigationConfig = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    labelKey: 'nav.dashboard',
    icon: DashboardIcon,
    path: '/',
  },
  {
    id: 'ticket-ops',
    label: 'Ticket Operations',
    labelKey: 'nav.ticketOps',
    icon: ConfirmationNumberIcon,
    children: [
      { id: 'scan', label: 'Scan Ticket', labelKey: 'nav.scan', path: '/scanner', icon: QrCodeScannerIcon, feature: 'SCAN_TICKET' },
      { id: 'sell', label: 'Sell Ticket', labelKey: 'nav.sell', path: '/sell', icon: ConfirmationNumberIcon, feature: 'PURCHASE_TICKET' },
      // DV-312: admin ticket transfer is on — see config/ticketTransfer.js.
      ...(TICKET_TRANSFER_ENABLED
        ? [{ id: 'transfer', label: 'Transfer Ticket', labelKey: 'nav.transfer', path: '/transfer', icon: SwapHorizIcon, feature: 'TRANSFER_TICKET' }]
        : []),
      { id: 'bulk-upload', label: 'Bulk Upload', labelKey: 'nav.bulkUpload', path: '/bulk-upload', icon: UploadFileIcon, feature: 'BULK_UPLOAD_TICKETS' },
      { id: 'refund', label: 'Refund Management', labelKey: 'nav.refund', path: '/refund-management', icon: MoneyOffIcon, feature: 'REFUND_TICKET' },
    ],
  },
  {
    id: 'events',
    label: 'Events',
    labelKey: 'nav.events',
    icon: EventIcon,
    children: [
      { id: 'event-mgmt', label: 'Event Management', labelKey: 'nav.eventMgmt', path: '/events', icon: EventIcon, feature: 'EVENT_MANAGEMENT' },
    ],
  },
  {
    id: 'content',
    label: 'Content',
    labelKey: 'nav.content',
    icon: VideoLibraryIcon,
    children: [
      { id: 'content-mgmt', label: 'Content Management', labelKey: 'nav.contentMgmt', path: '/content-management', icon: VideoLibraryIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'bundle-mgmt', label: 'Bundle Management', labelKey: 'nav.bundleMgmt', path: '/bundle-management', icon: FolderIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'category-tags', label: 'Categories & Tags', labelKey: 'nav.categoryTags', path: '/category-tag-management', icon: LocalOfferIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'subscription-mgmt', label: 'Subscriptions', labelKey: 'nav.subscriptionMgmt', path: '/subscription-management', icon: CardMembershipIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'content-assign', label: 'Assign Content', labelKey: 'nav.contentAssign', path: '/content-assign', icon: LinkIcon, feature: 'ASSIGN_CONTENT' },
    ],
  },
  {
    id: 'reporting',
    label: 'Operations & Reporting',
    labelKey: 'nav.reporting',
    icon: AssessmentIcon,
    children: [
      { id: 'audit', label: 'Audit', labelKey: 'nav.audit', path: '/audit', icon: ReceiptLongIcon, feature: 'AUDIT' },
      { id: 'payment-audit', label: 'Payment Audit', labelKey: 'nav.paymentAudit', path: '/payment-audit', icon: PaymentsIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'user-audit', label: 'User Audit', labelKey: 'nav.userAudit', path: '/user-audit', icon: ManageSearchIcon, feature: 'USER_AUDIT' },
      { id: 'content-payment-audit', label: 'Content Payment Audit', labelKey: 'nav.contentPaymentAudit', path: '/content/payment-audit', icon: ReceiptLongIcon, feature: 'CONTENT_PAYMENT_AUDIT' },
      { id: 'content-sub-audit', label: 'Content Subscription Audit', labelKey: 'nav.contentSubAudit', path: '/content/subscription-audit', icon: SubscriptionsIcon, feature: 'CONTENT_SUBSCRIPTION_AUDIT' },
      { id: 'content-analytics', label: 'Content Analytics', labelKey: 'nav.contentAnalytics', path: '/content/analytics', icon: BarChartIcon, feature: 'CONTENT_ANALYTICS' },
      { id: 'ibo-spending-report', label: 'Monthly IBO Spending', labelKey: 'nav.iboSpendingReport', path: '/ibo-spending-report', icon: AssessmentIcon, feature: 'CONTENT_PAYMENT_AUDIT' },
    ],
  },
  {
    id: 'user-team',
    label: 'User & Team Management',
    labelKey: 'nav.userTeam',
    icon: PeopleIcon,
    children: [
      { id: 'user-mgmt', label: 'User Management', labelKey: 'nav.userMgmt', path: '/user-management', icon: PeopleIcon, feature: 'USER_MANAGEMENT' },
      { id: 'team-mgmt', label: 'Team Management', labelKey: 'nav.teamMgmt', path: '/team-management', icon: GroupsIcon, feature: 'TEAM_MANAGEMENT' },
      { id: 'admin-mgmt', label: 'Admin Management', labelKey: 'nav.adminMgmt', path: '/admin-management', icon: AdminPanelSettingsIcon, feature: 'ADMIN_MANAGEMENT' },
      { id: 'user-verification', label: 'User Verification', labelKey: 'nav.userVerification', path: '/user-verification', icon: VerifiedUserIcon, feature: 'USER_VERIFICATION' },
      { id: 'feature-gates', label: 'Feature Gates', labelKey: 'nav.featureGates', path: '/feature-gates', icon: ToggleOnIcon, feature: 'USER_MANAGEMENT' },
      { id: 'user-hierarchy', label: 'User Hierarchy', labelKey: 'nav.userHierarchy', path: '/user-hierarchy', icon: AccountTreeIcon, feature: 'USER_HIERARCHY' },
    ],
  },
  {
    id: 'system',
    label: 'System',
    labelKey: 'nav.system',
    icon: SettingsIcon,
    children: [
      { id: 'feature-mgmt', label: 'Feature Management', labelKey: 'nav.featureMgmt', path: '/feature-management', icon: SettingsIcon, feature: 'FEATURE_MANAGEMENT' },
      { id: 'feedback-mgmt', label: 'Feedback Management', labelKey: 'nav.feedbackMgmt', path: '/feedback-management', icon: FeedbackIcon, feature: 'FEEDBACK_MANAGEMENT' },
      { id: 'banner-mgmt', label: 'Banner Management', labelKey: 'nav.bannerMgmt', path: '/banner-management', icon: AnnouncementIcon, feature: 'BANNER_MANAGEMENT' },
      { id: 'notification-templates', label: 'Notification Templates', labelKey: 'nav.notificationTemplates', path: '/notification-templates', icon: NotificationsActiveIcon, feature: 'NOTIFICATION_MANAGEMENT' },
      { id: 'notification-categories', label: 'Notification Categories', labelKey: 'nav.notificationCategories', path: '/notification-categories', icon: CategoryIcon, feature: 'NOTIFICATION_MANAGEMENT' },
      { id: 'mass-communication', label: 'Mass Communication', labelKey: 'nav.massCommunication', path: '/mass-communication', icon: CampaignIcon, feature: 'NOTIFICATION_MANAGEMENT' },
      { id: 'compliance-messages', label: 'Compliance Messages', labelKey: 'nav.complianceMessages', path: '/compliance-messages', icon: PolicyOutlinedIcon, feature: 'COMPLIANCE_MESSAGES' },
      { id: 'foundational-education', label: 'Foundational Education', labelKey: 'nav.foundationalEducation', path: '/foundational-education', icon: SchoolOutlinedIcon, feature: 'COMPLIANCE_MESSAGES' },
    ],
  },
  {
    id: 'books',
    label: 'Books',
    labelKey: 'nav.books',
    icon: MenuBookIcon,
    children: [
      { id: 'author-mgmt', label: 'Authors', labelKey: 'nav.authorMgmt', path: '/author-management', icon: PersonIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'book-mgmt', label: 'Book Management', labelKey: 'nav.bookMgmt', path: '/book-management', icon: MenuBookIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'book-bundle-mgmt', label: 'Book Bundles', labelKey: 'nav.bookBundleMgmt', path: '/book-bundle-management', icon: LibraryBooksIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'warehouse-mgmt', label: 'Warehouses', labelKey: 'nav.warehouseMgmt', path: '/warehouse-management', icon: WarehouseIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'shipping-mgmt', label: 'Shipping & Tax', labelKey: 'nav.shippingMgmt', path: '/shipping-management', icon: LocalShippingIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'tax-rate-mgmt', label: 'Tax Rates', labelKey: 'nav.taxRateMgmt', path: '/tax-rate-management', icon: GavelIcon, feature: 'EVENT_MANAGEMENT' },
      { id: 'book-order-mgmt', label: 'Book Orders', labelKey: 'nav.bookOrderMgmt', path: '/book-order-management', icon: ReceiptIcon, feature: 'EVENT_MANAGEMENT' },
    ],
  },
  {
    id: 'tools',
    label: 'Tools',
    labelKey: 'nav.tools',
    icon: BuildIcon,
    children: [
      { id: 'amway-tool', label: 'Amway Tool', labelKey: 'nav.amwayTool', path: '/amway-tool', icon: SearchIcon },
    ],
  },
];
